import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import Select from 'react-select';
import { Row, Col, Label, FormGroup, Input } from 'reactstrap';
import { func, object } from 'prop-types';
import IframeConstructorColorPicker from './IframeConstructorColorPicker';
import IframeConstructorRangeControl from './IframeConstructorRangeControl';
import CustomControl from '../CustomControl/CustomControl';
import { fonts } from './iframeConstructorConfig';


class IframeConstructorCommonControls extends Component {
  static propTypes = {
    handleFontChange: func.isRequired,
    handleFontFamilyChange: func.isRequired,
    handleFormChange: func.isRequired,
    validateFormColor: func.isRequired,
    settings: object.isRequired,
    config: object.isRequired,
  };

  state = {
    size: 0,
    maxWidth: 0,
  };

  componentDidMount() {
    this.setState(() => ({
      size: this.props.settings.font.size,
      maxWidth: this.props.settings.form.maxWidth,
    }));
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.settings.font.size !== this.props.settings.font.size ||
      prevProps.settings.form.maxWidth !== this.props.settings.form.maxWidth
    ) {
      this.setState(() => ({
        size: this.props.settings.font.size,
        maxWidth: this.props.settings.form.maxWidth,
      }));
    }
  }

  handleChange = e => {
    const { value, name } = e.target;
    this.setState(() => ({
      [name]: value,
    }));
  };

  render() {
    const {
      settings,
      config,
      handleFontChange,
      handleFontFamilyChange,
      handleFormChange,
      validateFormColor,
    } = this.props;
    const { size, maxWidth } = this.state;
    return (
      <div className="iframe-constructor-controls-block">
        <h3 className="iframe-constructor-controls-block-title">
          <FormattedMessage
            id="iframe_constructor.сontrols.common.title"
            defaultMessage="Basic settings"
          />
        </h3>

        <Row>
          <Col md="8">
            <FormGroup>
              <Label for="iframe-constructor-common-font-family">
                <FormattedMessage
                  id="iframe_constructor.сontrols.common.font.family"
                  defaultMessage="Font"
                />
              </Label>
              <Select
                id="iframe-constructor-common-font-family"
                name="family"
                value={settings.font.family}
                onChange={handleFontFamilyChange}
                options={fonts}
                clearable={false}
                searchable={false}
                className="Select--sm"
              />
            </FormGroup>
          </Col>
          <Col md="4">
            <FormGroup>
              <Label for="iframe-constructor-common-font-size">
                <FormattedMessage
                  id="iframe_constructor.сontrols.common.font.size"
                  defaultMessage="Size (px)"
                />
              </Label>
              <Input
                type="number"
                id="iframe-constructor-common-font-size"
                name="size"
                onChange={this.handleChange}
                onBlur={handleFontChange}
                value={size}
                min={config.font._MIN_SIZE}
                max={config.font._MAX_SIZE}
                bsSize="sm"
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col xl="4" lg="6">
            <IframeConstructorColorPicker
              name="bgColor"
              value={settings.form.bgColor}
              onChange={handleFormChange}
              validate={validateFormColor.bind(null, 'bgColor', config.form._DEFAULT_BG_COLOR)}
              id="ic--bgColor"
              label={{
                id: 'iframe_constructor.сontrols.common.form.color.bg',
                defaultMessage: 'Form background color',
              }}
            />
          </Col>

          <Col xl="4" lg="6">
            <IframeConstructorColorPicker
              name="textColor"
              value={settings.form.textColor}
              onChange={handleFormChange}
              validate={validateFormColor.bind(null, 'textColor', config.form._DEFAULT_TEXT_COLOR)}
              id="ic--textColor"
              label={{
                id: 'iframe_constructor.сontrols.common.form.color.text',
                defaultMessage: 'Text color',
              }}
            />
          </Col>

          <Col xl="4" lg="6">
            <IframeConstructorColorPicker
              name="additionalTextColor"
              value={settings.form.additionalTextColor}
              onChange={handleFormChange}
              validate={validateFormColor.bind(
                null,
                'additionalTextColor',
                config.form._DEFAULT_ADDITIONAL_TEXT_COLOR,
              )}
              id="ic--additionalTextColor"
              label={{
                id: 'iframe_constructor.сontrols.common.form.color.additional_text',
                defaultMessage: 'Additional text color',
              }}
            />
          </Col>
        </Row>

        <FormGroup>
          <CustomControl
            id="ic__form-max-width-status"
            name="enabledMaxWidth"
            type="checkbox"
            className="custom-control-xs"
            value={'enabledMaxWidth'}
            onChange={handleFormChange}
            checked={settings.form.enabledMaxWidth}
          >
            <FormattedMessage
              id="iframe_constructor.сontrols.common.form.max_width.checkbox"
              defaultMessage="Maximum width of the form (px)"
            />
          </CustomControl>

          <Row>
            <Col md="9">
              <IframeConstructorRangeControl
                value={settings.form.maxWidth}
                max={config.form._MAX_WIDTH}
                min={config.form._MIN_WIDTH}
                onChange={handleFormChange}
                name="maxWidth"
                disabled={!settings.form.enabledMaxWidth}
              />
            </Col>

            <Col md="3">
              <Input
                type="number"
                id="iframe-constructor-common-max-width"
                name="maxWidth"
                onChange={this.handleChange}
                onBlur={handleFormChange}
                value={maxWidth}
                min={config.form._MIN_WIDTH}
                max={config.form._MAX_WIDTH}
                bsSize="sm"
                disabled={!settings.form.enabledMaxWidth}
              />
            </Col>
          </Row>
        </FormGroup>
      </div>
    );
  }
}

export default IframeConstructorCommonControls;
